/*
 * Where: src/components/molecules/InfoCard.js
 * What: Molecule component for content cards.
 * Why: Compose atom-level typography into reusable card blocks.
 */
import React from 'react';

function InfoCard({ title, text }) {
    return (
        <article className="info-card">
            <h3>{title}</h3>
            <p>{text}</p>
        </article>
    );
}

export default InfoCard;
